<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('administration.mobile_feature.reset_password.reset_password') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'administration.mobile_feature.reset_password.reset_password'
            ),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12 d-flex justify-content-end">
            <ts-input
              style="width:300px"
              v-model="search"
              :placeholder="
                $t('administration.mobile_feature.reset_password.search')
              "
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ $store.getters.limitStringShow(record.comment) }}</td>
          <td>{{ record.device_imei }}</td>
          <td>{{ record.activated_type }}</td>
          <td>{{ record.full_name }}</td>
          <td>{{ record.login_name }}</td>
          <td class="text-center">
            <span v-if="model.login_name != record.login_name">*******</span>
            <input
              v-model="model.new_password"
              v-if="model.login_name == record.login_name"
              type="password"
              class="form-control"
              :class="{ 'is-invalid': errors.has('new_password') }"
              :placeholder="
                $t('administration.mobile_feature.reset_password.new_password')
              "
              style="width:84%; margin:0 auto;"
            />
          </td>
          <td class="text-center">
            <ts-button
              v-if="model.login_name == record.login_name"
              class="btn-xs btn-primary mr-2"
              @click="update(record)"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button
              @click="cancel"
              v-if="model.login_name == record.login_name"
              class="btn-xs btn-default"
            >
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              v-if="model.login_name != record.login_name"
              href="#"
              v-tooltip="
                $t(
                  'administration.mobile_feature.reset_password.reset_password'
                )
              "
              class="mr-2 text-primary"
              @click.prevent="resetPassword(record)"
            >
              <i class="fas fa-lock"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'reset-device-password',
  data() {
    return {
      model: {
        login_name: '',
        new_password: ''
      },
      loading: false,
      errors: new Errors()
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('resetDevicePassword', [
      'resources',
      'pagination',
      'notification_types'
    ]),
    search: {
      get() {
        return this.$store.state.resetDevicePassword.search
      },
      set(newValue) {
        this.$store.commit('resetDevicePassword/SET_SEARCH', newValue)
        this.$store.commit('resetDevicePassword/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          name: this.$t('administration.mobile_feature.reset_password.comment')
        },
        { name: this.$t('administration.mobile_feature.reset_password.imei') },
        {
          name: this.$t(
            'administration.mobile_feature.reset_password.activate_type'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.reset_password.full_name'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.reset_password.login_name'
          )
        },
        {
          name: this.$t(
            'administration.mobile_feature.reset_password.reset_password'
          ),
          style: 'text-align:center; width:18%'
        },
        {
          name: this.$t('administration.mobile_feature.reset_password.actions'),
          style: 'text-align:center; width:10%'
        }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('resetDevicePassword/fetch', attributes)
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    resetPassword(record) {
      this.errors = new Errors()
      this.model.login_name = record.login_name
      this.model.new_password = ''
      this.model.login_name = record.login_name
    },
    update(record) {
      record._deleting = true
      this.$store
        .dispatch('resetDevicePassword/update', Object.assign({}, this.model))
        .then(response => {
          this.cancel()
          record._deleting = false
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          record._deleting = false
        })
    },
    cancel() {
      this.errors = new Errors()
      this.model.login_name = ''
      this.model.new_password = ''
      this.model.login_name = ''
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('resetDevicePassword/RESET_STATE')
    }
    next()
  }
}
</script>

<style lang="css" scoped>
table td {
	vertical-align : middle;
}
</style>
